import { lazy } from 'react';

export const PaymentrecordPage = lazy(() => import('./page-list'));
